export enum BrsAccessRulesKeyEnum {
  // --- Модуль BRS (Платежи) ---

  // --- Раздел BRS.SECTIONS.BRS (Платежи) ---
  // Вкладки
  BRS_BRS_TASK_READ = 'BRS_BRS_TASK_READ',
  BRS_BRS_TASK_WRITE = 'BRS_BRS_TASK_WRITE',

  BRS_BRS_DDS_READ = 'BRS_BRS_DDS_READ',

  BRS_BRS_PAYMENT_CALENDAR_READ = 'BRS_BRS_PAYMENT_CALENDAR_READ',
  BRS_BRS_PAYMENT_CALENDAR_WRITE = 'BRS_BRS_PAYMENT_CALENDAR_WRITE',

  BRS_BRS_TEMPLATE_READ = 'BRS_BRS_TEMPLATE_READ',
  BRS_BRS_TEMPLATE_WRITE = 'BRS_BRS_TEMPLATE_WRITE',

  BRS_BRS_STATUS_READ = 'BRS_BRS_STATUS_READ',
  BRS_BRS_STATUS_WRITE = 'BRS_BRS_STATUS_WRITE',

  BRS_BRS_SETTINGS_READ = 'BRS_BRS_SETTINGS_READ',
  BRS_BRS_SETTINGS_WRITE = 'BRS_BRS_SETTINGS_WRITE',

  BRS_BRS_PAYMENT_SCENARION_READ = 'BRS_BRS_PAYMENT_SCENARION_READ',
  BRS_BRS_PAYMENT_SCENARION_WRITE = 'BRS_BRS_PAYMENT_SCENARION_WRITE',

  // Разрешения BRS
  BRS_BRS_ACCESS_TO_ALL_SAVED_FILTERS = 'BRS_BRS_ACCESS_TO_ALL_SAVED_FILTERS',
  BRS_BRS_READ_ALL_TASKS = 'BRS_BRS_READ_ALL_TASKS',
  BRS_BRS_EDIT_OTHER_USERS_TASKS = 'BRS_BRS_EDIT_OTHER_USERS_TASKS',
  BRS_BRS_APPROVE_INSTEAD_OF_OTHERS = 'BRS_BRS_APPROVE_INSTEAD_OF_OTHERS',
  BRS_BRS_DELETE_OTHER_USER_TASK_COMMENTS = 'BRS_BRS_DELETE_OTHER_USER_TASK_COMMENTS',
  BRS_BRS_REFUSE_AGGREED_AND_SENT_TASKS = 'BRS_BRS_REFUSE_AGGREED_AND_SENT_TASKS',
  BRS_BRS_READ_ALL_PLANNED_INCOMES = 'BRS_BRS_READ_ALL_PLANNED_INCOMES',
  BRS_BRS_EDIT_OTHER_USERS_PLANNED_INCOMES = 'BRS_BRS_EDIT_OTHER_USERS_PLANNED_INCOMES',
  BRS_BRS_DELETE_OTHER_USER_PLANNED_INCOME_COMMENTS = 'BRS_BRS_DELETE_OTHER_USER_PLANNED_INCOME_COMMENTS',
  BRS_BRS_MAKE_PAID_UNDERPAYMENT_TASKS = 'BRS_BRS_MAKE_PAID_UNDERPAYMENT_TASKS',
}
